import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../contexts';
import { fetchFaqById, submitUpdateFaq, successAction } from './actions';
import FormFaq from './FormFaq';

export default function Form(
  // {
  //   item = {},
  //   type = null
  // }
) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { setBreadcrumbs } = useContext(AppContext);
  const [afterSubmit, setAfterSubmit] = useState(false);

  const {
    faqId = ''
  } = queryString.parse(location.search.replace('?', ''));

  useEffect(() => {
    setBreadcrumbs(['Pengaturan FAQ', 'Edit FAQ']);
    dispatch(successAction(null, 'FaqById'));

    if (faqId) {
      dispatch(fetchFaqById(faqId));
    }
  }, [faqId]);

  const {
    dataSubmitUpdateFaq,
    isLoadingSubmitUpdateFaq
  } = useSelector((s) => s.faq);

  useEffect(() => {
    if (afterSubmit && !isLoadingSubmitUpdateFaq) {
      navigate(`/faq`);
    }
  }, [dataSubmitUpdateFaq, isLoadingSubmitUpdateFaq]);

  const handleSubmit = (values) => {
    dispatch(submitUpdateFaq(faqId, values, () => setAfterSubmit(true)));
  };

  return (
    <FormFaq
      onSubmit={handleSubmit}
      type={'edit'}
    />
  );
}

Form.propTypes = {
  item: PropTypes.object,
  type: PropTypes.string,
};
